import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Card } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  body: {
    background: theme.palette.bgElements,
    minHeight: '50vh',
    padding: '10px 10px'
  },
  itemWrap: {
    fontWeight: 500
  },
  itemLabel: {
    fontWeight: 200
  }
}));

function Warrant(props) {
  const { data, themeMode } = props;
  const classes = useStyles();

  if (data !== null) {
    return (
      <div className="table-responsive">
        <table
          className={clsx(
            'table',
            themeMode === 'night' && 'table-pts-night',
            themeMode === 'day' && 'table-pts-day',
            'text-nowrap',
            'mb-0'
          )}>
          <thead>
            <tr>
              <th className="bg-white">Issued</th>
              <th className="bg-white text-center">Arrest</th>
              <th className="bg-white text-center">Expiration</th>
              <th className="bg-white text-center">Disposition</th>
              <th className="bg-white text-center">Description</th>
              <th className="bg-white text-center">Is Bondable</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => {
              return (
                <tr key={idx}>
                  <td>
                    {row.IssuedDate
                      ? moment(row.IssuedDate).format('MM/DD/YYYY')
                      : ''}
                  </td>
                  <td>
                    {row.ArrestDate
                      ? moment(row.ArrestDate).format('MM/DD/YYYY')
                      : ''}
                  </td>
                  <td>
                    {row.ExpirationDate
                      ? moment(row.ExpirationDate).format('MM/DD/YYYY')
                      : ''}
                  </td>
                  <td>{row.Disposition}</td>
                  <td>{row.StatueDescription}</td>
                  <td className="text-center">
                    <div
                      className={clsx(
                        'badge',
                        row.IsBondAllowed === true &&
                          'bg-neutral-success text-success',
                        row.IsBondAllowed === false &&
                          'bg-neutral-danger text-danger'
                      )}>
                      {row.IsBondAllowed === true ? 'Yes' : 'No'}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <Card className="card-box bg-neutral-warning border-1 card-border-top border-warning text-center p-3">
        <h4 style={{ marginBottom: 0, color: 'black' }}>
          Sorry, no warrants found.
        </h4>
      </Card>
    );
  }
}

export default Warrant;
